/* eslint new-cap:0 */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import template from '../template/adgroup-editor.pug';

export default class AdgroupEditor extends Backbone.View {
  initialize({
    i18n,
    SearchBidView,
    BiddingStrategyView,
    model,
  }) {
    this.i18n = i18n;
    this.model = model;

    this.searchBidView = new SearchBidView({
      adgroup: undefined,
      getKeywordsCb: () => [],
      budget: 0,
      showTrafficEstimation: false,
      languages: [],
      newI18n: i18n,
    });

    this.biddingStrategyView = new BiddingStrategyView({
      entityType: 'AdGroup',
      biddingStrategyType: 'EnhancedCpc',
    });
  }

  render() {
    this.$el.append(template({ i18n: this.i18n }));
    ko.applyBindings(this.model, this.el);
    // Since we can't initialize AdgroupViewModel with default value
    // Manually set default adgroup name and bid after render
    this.searchBidView.viewModel.SearchBid(this.model.SearchBid);

    this.$('.bidding-strategy-container').append(this.biddingStrategyView.render().el);
    this.$('.bidding-strategy-container .col-sm-6 select').remove();
    this.$('.bidding-strategy-container .col-sm-6 span').remove();
    this.$('.bidding-strategy-container .col-sm-2').addClass('control-label');
    this.$('.bidding-strategy-container .col-sm-6').addClass('col-sm-4').removeClass('col-sm-6');
    this.$('.bidding-strategy-container .form-control-static').get(0).childNodes[0].nodeValue = this.i18n.getString('BidStrategySetting_Message_NoConversionTracking')
                                                                                                || 'You need to have conversion tracking set up to use this bid strategy. ';
    this.$('.bidding-strategy-container .form-control-static').prepend(`<div>${this.i18n.getString('BidStrategy_EnhancedCPC') || 'Enhanced CPC'}</div>`);

    this.$('.search-bid__container').append(this.searchBidView.render().el);
    this.$('.search-bid__container .form-group:nth-child(1)').remove();
    this.$('.search-bid__container .control-label').remove();
    this.$('.search-bid__container .col-sm-2').addClass('col-sm-6').removeClass('col-sm-2');

    return this;
  }

  getAdGroup() {
    const adGroupToSave = {
      AdGroupName: this.model.AdGroupName(),
      Bid: this.searchBidView.getValues().SearchBid,
    };

    return adGroupToSave;
  }

  validate() {
    return _.every([
      this.model.AdGroupName.isValid(),
      this.searchBidView.validate(),
    ]);
  }
}
